module.exports = __webpack_public_path__ + "static/media/take-look.269e0d93.svg";